const initCharacterParallax = () => {
  const section = document.querySelector('.hero__characters');

  if (!section) return;

  const parallaxItems = section.querySelectorAll('[data-parallax]');

  if (!parallaxItems.length) return;

  let ticking = false;

  const updateParallax = () => {
    const viewportHeight = window.innerHeight;
    const rect = section.getBoundingClientRect();

    if (rect.bottom < 0 || rect.top > viewportHeight) {
      ticking = false;
      return;
    }

    const progress =
      (viewportHeight - rect.top) / (viewportHeight + rect.height);

    parallaxItems.forEach((item) => {
      const speed = parseFloat(item.dataset.parallax) || 0;

      const offset = progress * speed;

      item.style.transform = `translate3d(0, ${offset}vh, 0)`;
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(updateParallax);
  };

  window.addEventListener('scroll', requestUpdate, {
    passive: true,
  });

  window.addEventListener('resize', requestUpdate);

  updateParallax();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCharacterParallax);
} else {
  initCharacterParallax();
}
